import { BillingSpaceSectionWrapper, PeriodContextLabel } from "../styles"
import { BillingAddress, DateRange } from "../queries"
import { useTranslation } from "react-i18next"
import BillingDataTable from "./BillingDataTable"
import BillingStateCard from "./BillingStateCard"
import { formatPeriodLong, sortSnapshotsByPeriod } from "./billingUtils"

export default function BillingSpaceSection({
    billingAddress,
    period,
    onExpandPeriod
}: {
    billingAddress: BillingAddress
    period: DateRange
    onExpandPeriod?: () => void
}) {
    const { t, i18n } = useTranslation()

    if (!billingAddress.partnerBillingSpace) {
        return <BillingStateCard title={t('facturation.partner-billing-space-not-activated')} />
    }

    const snapshots = sortSnapshotsByPeriod(billingAddress.retroCommissionSnapshots)

    return <BillingSpaceSectionWrapper>
        <header>
            <div className="header-main">
                <h3>{billingAddress.shortname}</h3>
                {billingAddress.fullAddress && <p>{billingAddress.fullAddress}</p>}
            </div>
            <div className="header-right">
                <PeriodContextLabel>
                    {t('facturation.period.analyzed-range-label')}{' '}
                    <strong style={{ color: '#000' }}>
                        {formatPeriodLong(period.startDate, i18n.language)}
                        {' → '}
                        {formatPeriodLong(period.endDate, i18n.language)}
                    </strong>
                </PeriodContextLabel>
            </div>
        </header>

        {snapshots.length === 0 && (
            <BillingStateCard
                title={t('facturation.no-snapshots')}
                description={t('facturation.no-snapshots-hint')}
                actionLabel={t('facturation.no-snapshots-action')}
                onAction={onExpandPeriod}
            />
        )}

        {snapshots.length > 0 && (
            <BillingDataTable billingAddress={billingAddress} />
        )}
    </BillingSpaceSectionWrapper>
}
